import type {
  CoachingGoal,
  CoachingGoalReflection,
} from '@efdigital/ll-addon-data';
import { DataTypeCoaching } from '@efdigital/ll-addon-data/data-types';
import { createRecord, query } from '@warp-drive/utilities/json-api';

import { jsonApiOptions, page } from '../../json-api.ts';

const MAX_REFLECTIONS_PER_PLAN = 100;

export function queryCoachingGoalReflectionsByPlan(coachingPlanId: string) {
  return query<CoachingGoalReflection>(
    DataTypeCoaching.CoachingGoalReflection,
    {
      'filter[coachingPlan.id]': coachingPlanId,
      ...page({ offset: 0, limit: MAX_REFLECTIONS_PER_PLAN }),
      'sort[]': '-createdAt',
    },
    jsonApiOptions
  );
}

export function queryCoachingGoalReflectionsByGoal(coachingGoalId: string) {
  return query<CoachingGoalReflection>(
    DataTypeCoaching.CoachingGoalReflection,
    {
      'filter[coachingGoal.id]': coachingGoalId,
      ...page({ offset: 0, limit: MAX_REFLECTIONS_PER_PLAN }),
      'sort[]': '-createdAt',
    },
    jsonApiOptions
  );
}

export function createCoachingGoalReflection(
  reflection: CoachingGoalReflection,
  goal: CoachingGoal
) {
  const init = createRecord(reflection, jsonApiOptions);

  init.body = JSON.stringify(
    coachingGoalReflectionCreateDocument(reflection, goal)
  );
  init.headers.set('Content-Type', 'application/vnd.api+json');
  return init;
}

export function coachingGoalReflectionCreateDocument(
  reflection: Pick<CoachingGoalReflection, 'body'>,
  goal: Pick<CoachingGoal, 'id'>
) {
  return {
    data: {
      type: DataTypeCoaching.CoachingGoalReflection,
      attributes: {
        body: reflection.body,
      },
      relationships: {
        coachingGoal: {
          data: {
            type: DataTypeCoaching.CoachingGoal,
            id: goal.id,
          },
        },
      },
    },
  };
}
